import { useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

export function useHoardingTypes({ includeInactive = false } = {}) {
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api.get("/business/hoarding-types", {
      params: includeInactive ? { include_inactive: "true" } : undefined,
      skipGlobalLoader: true,
    })
      .then(({ data }) => {
        if (!cancelled) setTypes(Array.isArray(data) ? data : []);
      })
      .catch(() => {
        if (!cancelled) setTypes([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [includeInactive]);

  const names = useMemo(() => types.filter((type) => type.is_active !== false).map((type) => type.name), [types]);

  return { types, loading, names };
}
